(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-and-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiperElement = document.querySelector('.image-slider__swiper');
    if (!swiperElement) return;

    const currentSlideElement = document.querySelector('.image-slider__current-slide');
    const totalSlides = document.querySelector('.image-slider__total-slides').textContent;
    const prevButton = document.querySelector('.image-slider__nav-button--prev');
    const nextButton = document.querySelector('.image-slider__nav-button--next');

    // Initialize Swiper
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: false,
      autoHeight: true,
      observer: true,
      observeParents: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      on: {
        init: function () {
          updateCounter(this);
        },
        slideChange: function () {
          updateCounter(this);
        },
      },
    });

    function updateCounter(swiper) {
      if (currentSlideElement) {
        currentSlideElement.textContent = swiper.activeIndex + 1;
      }

      // Update button states
      if (prevButton) {
        prevButton.style.opacity = swiper.isBeginning ? '0.3' : '1';
      }
      if (nextButton) {
        nextButton.style.opacity = swiper.isEnd ? '0.3' : '1';
      }
    }

    // Connect custom navigation buttons to Swiper
    if (prevButton) {
      prevButton.addEventListener('click', function () {
        swiper.slidePrev();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        swiper.slideNext();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-content-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiperElement = document.querySelector('.image-slider__swiper');
    if (!swiperElement) return;

    const currentSlideElement = document.querySelector('.image-slider__current-slide');
    const totalSlides = document.querySelector('.image-slider__total-slides').textContent;
    const prevButton = document.querySelector('.image-slider__nav-button--prev');
    const nextButton = document.querySelector('.image-slider__nav-button--next');

    // Initialize Swiper
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: false,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      on: {
        init: function () {
          updateCounter(this);
        },
        slideChange: function () {
          updateCounter(this);
        },
      },
    });

    function updateCounter(swiper) {
      if (currentSlideElement) {
        currentSlideElement.textContent = swiper.activeIndex + 1;
      }

      // Update button states
      if (prevButton) {
        prevButton.style.opacity = swiper.isBeginning ? '0.3' : '1';
      }
      if (nextButton) {
        nextButton.style.opacity = swiper.isEnd ? '0.3' : '1';
      }
    }

    // Connect custom navigation buttons to Swiper
    if (prevButton) {
      prevButton.addEventListener('click', function () {
        swiper.slidePrev();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        swiper.slideNext();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
